<ol>
    @for (entry of visibleResults(); track entry.robot.id) {
        <li>
            <robot-selector-cobot-card
                [robot]="entry.robot"
                [bestMatchLabel]="bestMatchLabel()"
                [viewProductLabel]="viewProductLabel()"
                [isBestMatch]="markBestMatch() && entry.isBestMatch" />
        </li>
    }
</ol>
